import React from 'react';

const EditButton = props => {
  let overallScale = 250 / props.measurements.overallWidth;
  if (props.measurements.overallWidth <= 300) {
    overallScale = 150 / props.measurements.overallWidth;
  }

  let margin = (props.width / 10) * overallScale + '%';
  let angleShift = '0%';

  if (props.wardrobeConfig.is_corner === true) {
    margin = 0 + '%';
  }

  const style = {
    marginLeft: margin,
    marginRight: margin,
    left: angleShift,
  };

  return (
    <button
      style={style}
      className="edit-button"
      onClick={props.setWardrobeActive}
      title="Edytuj szafę">
      <span className="icon-edit" />
    </button>
  );
};

export default EditButton;
